<template>
  <standard-dialog
    v-model="model"
    :title="$t('add_to_quote_request')"
    icon="mdi-cart-plus"
    :save-text="$t('add')"
    @save="
      $emit('groceryAdded', parsedGrocery);
      model = false;
    "
  >
    <v-form ref="form" v-model="valid">
      <grocery-picker v-model="grocery" :groceries="groceries" />
      <text-field
        :label="$t('warehouse.warehouse_status')"
        type="number"
        :value="grocery ? selectedInventoryGrocery?.quantity || 0 : null"
        :suffix="grocery?.measure || ''"
        readonly
      />
      <text-field
        v-model="quantity"
        :label="$t('quantity') + $t('for_order')"
        type="number"
        :suffix="grocery ? grocery.measure : ''"
        :rules="[rules.required]"
      />
    </v-form>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import GroceryPicker from "@/components/groceries/fields/GroceryPicker.vue";
import warehouseService from "@/services/warehouse";
import groceryService from "@/services/grocery";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

export default {
  mixins: [hasModel, hasValidation, hasSnackbar],
  props: {
    warehouse: {
      type: [Object, null, undefined],
      required: true,
    },
  },
  components: {
    GroceryPicker,
    StandardDialog,
  },
  data: () => ({
    groceries: [],
    grocery: null,
    quantity: null,
    loading: false,
    inventory: [],
    inventoryLoaded: false,
    groceriesLoaded: false,
  }),
  methods: {
    async getInventory() {
      this.loading = true;
      try {
        const { data } = await warehouseService.getInventory();
        this.inventory = data;
        this.inventoryLoaded = true;
      } catch (error) {
        this.showErrorSnackbar(error, this.$t("error_loading_inventory"));
      } finally {
        this.loading = false;
      }
    },
    async getGroceries() {
      this.loading = true;
      try {
        const { data } = await groceryService.getGroceries();
        this.groceries = data;
        this.groceriesLoaded = true;
      } catch (error) {
        this.showErrorSnackbar(error, this.$t("error_loading_groceries"));
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    parsedGrocery() {
      return {
        id: this.grocery.id,
        code: this.grocery.code,
        grocery_id: this.grocery.id,
        name: this.grocery.name,
        measure: this.grocery.measure,
        quantity: Number(this.quantity),
        warehouse_stock: this.selectedInventoryGrocery?.quantity || 0,
        warehouse_id: this.warehouse.id,
        transaction_type: "order",
        warehouse: this.warehouse,
        grocery: this.grocery,
      };
    },
    selectedInventoryGrocery() {
      return this.inventory.find(
        (item) =>
          item.grocery_id === this.grocery?.id && item.warehouse_id === this.warehouse.id
      );
    },
  },
  watch: {
    model(newVal) {
      if (newVal) {
        if (!this.inventoryLoaded) {
          this.getInventory();
        }
        if (!this.groceriesLoaded) {
          this.getGroceries();
        }
      } else {
        this.grocery = null;
        this.quantity = null;
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
